import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'
import { type CMSLayout } from '@/features/cms/components/CMS/types'
import { GridLayoutContainer } from '@/features/shared/styles/layout'

export const CMSShelfLayoutContainer = styled(GridLayoutContainer)`
  @media ${screenSizes.max_mobile} {
    max-width: 100%;
  }

  @media ${screenSizes.tablet} {
    width: 100%;
  }

  @media ${screenSizes.only_tablet} {
    max-width: 100%;
  }
`

export const CMSShelfLayoutContainerConditional = styled(GridLayoutContainer)<{
  layout?: CMSLayout['content_type_id'] | null
}>`
  @media ${screenSizes.max_mobile} {
    max-width: 100%;
  }

  @media ${screenSizes.tablet} {
    width: ${({ layout }) => (layout === 'page_layout' ? '100%' : 'auto')};
  }

  @media ${screenSizes.only_tablet} {
    max-width: 100%;
  }
`
